export const COMPANY_ROUTE_PATHNAME = '/compnay'
export const PORTFOLIO_SINGLE_PATHNAME = '/portfolio'
export const PORTFOLIO_HOME_PATHNAME = '/portfolio/home'
export const PORTFOLIO_LAST_WEEK_PATHNAME = '/portfolio/lastweek'
export const LOGIN_PATHNAME = '/login'
export const SIGNUP_PATHNAME = '/signup'
export const HOME_PATHNAME = '/'